import {
    type FragmentType,
    getFragmentData,
    graphql
} from '~/resources/graphql'
import { computed, inject, provide } from 'vue'
import type { InjectionKey, Ref } from 'vue'

export const UseLoginModalOrganizationFragment = graphql(`
    fragment UseLoginModalOrganizationFragment on Organization {
        rememberMeDefault
        onlineProfileAgeMinimum
        loginContactMethodDisplayOrder
        loginHcaptchaEnabled
        facilityLocationGroups {
            id
            name
            facilities {
                id
                label
            }
        }
    }
`)

type LoginModalOrganizationFragment = FragmentType<
    typeof UseLoginModalOrganizationFragment
>

const loginModalOrganizationInjectionKey: InjectionKey<
    Ref<LoginModalOrganizationFragment | null>
> = Symbol('loginModalOrganizationInjectionKey')

export function provideLoginModalOrganizationFragment(
    organization: Ref<LoginModalOrganizationFragment | null>
) {
    provide(loginModalOrganizationInjectionKey, organization)
}

export function useLoginModalOrganization() {
    const organization = inject(loginModalOrganizationInjectionKey)

    return computed(() => {
        if (organization === undefined || organization.value === null) {
            throw new Error('No Login Modal Organization')
        }

        // Login configuration is fetched once in app-level organization context
        // so modal consumers can read it without each layout wiring fragments.
        return getFragmentData(
            UseLoginModalOrganizationFragment,
            organization.value
        )
    })
}
